class GiftThresholdMeter extends HTMLElement {
    connectedCallback() {
        this.threshold = parseFloat(this.dataset.giftThreshold || '100');
        this.progress = this.querySelector('[data-gift-progress]');
        this.track = this.querySelector('.gift-progress-track');
        this.meter = this.querySelector('[data-gift-progress-meter]');
        this.message = this.querySelector('[data-gift-message]');
        this.refresh = this.refresh.bind(this);

        this.refresh();

        const cartCount = document.querySelector('[data-cart-count]');
        if (cartCount) {
            this.cartObserver = new MutationObserver(() => {
                window.clearTimeout(this.refreshTimer);
                this.refreshTimer = window.setTimeout(this.refresh, 180);
            });
            this.cartObserver.observe(cartCount, { childList: true, characterData: true, subtree: true });
        }

        document.addEventListener('change', this.refresh, true);
    }

    disconnectedCallback() {
        if (this.cartObserver) this.cartObserver.disconnect();
        document.removeEventListener('change', this.refresh, true);
        window.clearTimeout(this.refreshTimer);
    }

    refresh() {
        if (typeof Shopify === 'undefined' || typeof Shopify.getCart !== 'function') return;

        Shopify.getCart((cart) => {
            const total = Number(cart.total_price || 0) / 100;
            const percent = Math.min(100, Math.max(0, (total / this.threshold) * 100));
            const remaining = Math.max(0, this.threshold - total);

            if (cart.item_count === 0) {
                this.progress.classList.add('gift-progress-hidden');
            } else {
                this.progress.classList.remove('gift-progress-hidden');
            }

            this.meter.style.width = percent + '%';
            this.track.setAttribute('aria-valuenow', Math.round(percent));

            if (total >= this.threshold) {
                this.classList.add('is-complete');
                this.message.innerHTML = '<strong>Sorpresa sbloccata ✨</strong>';
            } else if (total > 0) {
                this.classList.remove('is-complete');
                const formattedRemaining = Shopify.formatMoney(Math.round(remaining * 100), window.money_format);
                this.message.innerHTML = 'Sei a <strong>' + formattedRemaining + '</strong> da una sorpresa speciale ✨';
            } else {
                this.classList.remove('is-complete');
                const formattedThreshold = Shopify.formatMoney(Math.round(this.threshold * 100), window.money_format);
                this.message.innerHTML = 'Raggiungi <strong>' + formattedThreshold + '</strong> per una sorpresa speciale ✨';
            }

            if (window.jQuery && $('.dropdown-item[data-currency]').length) {
                if ((window.show_multiple_currencies && typeof Currency !== 'undefined' && Currency.currentCurrency !== shopCurrency) || window.show_auto_currency) {
                    Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                }
            }
        });
    }
}

window.addEventListener('load', () => {
    if (!customElements.get('gift-threshold-component')) {
        customElements.define('gift-threshold-component', GiftThresholdMeter);
    }
});
